import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000' });

export default function Login({ onLogin }) {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!username.trim() || !password.trim()) return setError('Please fill in all fields');
    setLoading(true);
    setError('');
    try {
      const res = await API.post(`/api/auth/${mode}`, { username, password });
      localStorage.setItem('cms_token', res.data.token);
      localStorage.setItem('cms_user', JSON.stringify(res.data.user));
      onLogin(res.data.user);
    } catch(err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div className="login-bg">
      <div className="login-box">
        <div className="login-brand">
          <div className="login-brand-mark">CMS</div>
          <span className="login-brand-name">SUN KIND CMS</span>
        </div>
        <h2 className="login-title">{mode === 'login' ? 'Sign in' : 'Create account'}</h2>
        <p className="login-sub">
          {mode === 'login' ? 'Welcome back! Enter your credentials.' : 'First user becomes admin automatically.'}
        </p>

        {error && <div className="login-error">{error}</div>}

        <label className="login-label">Username</label>
        <input className="login-input" value={username} onChange={e => setUsername(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="Enter username" autoFocus />

        <label className="login-label">Password</label>
        <input className="login-input" type="password" value={password} onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          placeholder="Enter password" />

        <button className="login-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : 'Create Account'}
        </button>

        <div className="login-switch">
          {mode === 'login' ? (
            <>Don't have an account? <button onClick={() => { setMode('register'); setError(''); }}>Register</button></>
          ) : (
            <>Already have an account? <button onClick={() => { setMode('login'); setError(''); }}>Sign in</button></>
          )}
        </div>
      </div>
    </div>
  );
}
